module.exports = __webpack_public_path__ + "static/img/weixin_erweim3.e04e564.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/weixin_erweim3.png
// module id = ytuI
// module chunks = 16